<template>
    <div class="p-4 md:p-8 mt-4 border w-full md:w-3/4 col-span-6 grid grid-cols-2 relative shadow-lg">
        <div class="col-span-2">
            <span class="text-lg font-semibold text-brand-blue">
                Vehicle {{ index + 1 }}
            </span>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 pt-3">
                <div class="col-span-1">
                    <p class="font-bold">Registration</p>
                    <span>{{ modelValue.registration }}</span>
                </div>
                <div class="col-span-1">
                    <p class="font-bold">Type</p>
                    <span>{{ modelValue.type.type }}</span>
                </div>
            </div>
            <div class="col-span-6 sm:col-span-3 pt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="col-span-1">
                    <DataListInput
                        label="Vehicle Make"
                        v-model="modelValue.make"
                        styling="capitalize"
                        :name="'vehicles['+ modelValue.registration +'][make]'"
                        :options="vehicleMakeList"
                        option-slug="vehicle-make-list"
                        :strict="true"
                    ></DataListInput>
                    <small class="text-red-500" v-if="errors?.['vehicles.' + index + '.make']?.length">{{ errors['vehicles.' + index + '.make'][0] }}</small>
                </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 pt-3">
                <div class="col-span-1">
                    <TextInput
                        label="Colour"
                        :name="'vehicles['+ modelValue.registration +'][colour]'"
                        v-model="modelValue.colour"
                    ></TextInput>
                </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 pt-3">
                <div class="col-span-1">
                    <TextInput
                        label="Party size"
                        :name="'vehicles['+ modelValue.registration +'][party_size]'"
                        type="number"
                        v-model="modelValue.partySize"
                    ></TextInput>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TextInput from '../TextInput.vue';
import DataListInput from '../DataListInput.vue';

export default {
    data() {
        return {
            makeDropdown: null,
        };
    },
    props: {
        index: { type: Number, required: true },
        colourTheme: { type: String, required: true },
        errors: { type: Object, default: () => {} },
        modelValue: { type: Object },
    },
    watch: {
        makeDropdown(val) {
            if (val !== 'other') {
                this.modelValue.make = val;
            } else {
                this.modelValue.make = null;
            }
        },
    },
    components: {
        TextInput,
        DataListInput,
    },
};
</script>

<style scoped>

.tooltip {
    @apply invisible absolute;
}

.has-tooltip:hover .tooltip {
    @apply visible z-50;
}

</style>
